import React from 'react';
import './LoaderModal.css';

export function LoaderModal({ open, message }) {
  if (!open) return null;

  return (
    <div className="c-modal c-modal--loader c-modal--visible js-js-modal-loader">
      <div className="c-modal__loader js"></div>
      {message && (
        <div className="c-modal__message">
          {message}
        </div>
      )}
    </div>
  );
}

export default LoaderModal;
